import {
    type GemsApi_StoneShape,
    type GemsApiStoneShapeWithInfoFragment,
    StoneShapeCode,
} from '@/graphql/api'
import { computed, type ComputedRef, toValue } from 'vue'
import {
    type ExcludeNull,
    includes,
    isNotUndefinedOrNull,
    type RefOrGetter,
} from '@/helpers'

import { allowedShapes } from '@/domain/stone/search/allowed-shapes.ts'

type GemsApiStoneShapeWithInfoFragmentInfo = ExcludeNull<
    GemsApiStoneShapeWithInfoFragment['info']
>

export type GemsApiStoneShapeWithInfoWithoutSystemCode = Omit<
    GemsApiStoneShapeWithInfoFragmentInfo,
    'systemCode'
>
export type GemsApiStoneShapeWithInfoWithGemsApiShapeSystemCode =
    GemsApiStoneShapeWithInfoWithoutSystemCode & {
        systemCode: GemsApi_StoneShape
        monolithSystemCode: StoneShapeCode
    }

export function useAllowedShapesWithInfo(
    shapes: RefOrGetter<GemsApiStoneShapeWithInfoFragment[] | undefined>
): ComputedRef<
    GemsApiStoneShapeWithInfoWithGemsApiShapeSystemCode[] | undefined
> {
    return computed(() => {
        return toValue(shapes)
            ?.filter((s: GemsApiStoneShapeWithInfoFragment) =>
                includes(allowedShapes, s.code)
            )
            .map(
                (
                    s: GemsApiStoneShapeWithInfoFragment
                ):
                    | GemsApiStoneShapeWithInfoWithGemsApiShapeSystemCode
                    | undefined => {
                    if (s.info) {
                        return {
                            ...s.info,
                            systemCode: s.code,
                            monolithSystemCode: s.info.systemCode,
                        }
                    }

                    return undefined
                }
            )
            .filter(isNotUndefinedOrNull)
    })
}

export function gemsApiShapeToShapeCode(
    shape: GemsApi_StoneShape | undefined
): StoneShapeCode | undefined {
    if (includes(Object.values(StoneShapeCode), shape)) {
        return shape
    }

    return undefined
}
